function showMeHideMe(showMe, hideMe) {
    hideMe.hide();
    showMe.removeClass('hidden');
    showMe.show();
}

effectsContentChangedFn = null;


$.fn.showAnimatedIf = function (condition, animateType, completionFn) {
    animateType = nullIfUndefined(animateType);
    completionFn = nullIfUndefined(completionFn);

    if ($(this).hasClass('animating')) {
        return;
    }
    $(this).addClass('animating');
    if (condition) {
        if(animateType === 'fade') {
            $(this).fadeIn(function () {
                $(this).removeClass('animating');
                plannerApplication.controllers.navigationContoller.navContentsResized();
                if(completionFn != null) completionFn();
            });
        } else {
            $(this).slideDown(function () {
                $(this).removeClass('animating');
                plannerApplication.controllers.navigationContoller.navContentsResized();
                if(completionFn != null) completionFn();
            });
        }

    } else {
        if(animateType === 'fade') {
            $(this).fadeOut(function () {
                $(this).removeClass('animating');
                plannerApplication.controllers.navigationContoller.navContentsResized();
                if(completionFn != null) completionFn();
            });
        } else {
            $(this).slideUp(function () {
                $(this).removeClass('animating');
                plannerApplication.controllers.navigationContoller.navContentsResized();
                if(completionFn != null) completionFn();
            });
        }
    }
};
